'use strict';

function newsletterInscription() {
  const submit = $('.form-newsletter__submit');

  function init() {
    submit.click(submitForm);
  }

  function clearErrors() {
    $('.form-newsletter__notif--error').remove();
  }

  function submitForm(e) {
    e.preventDefault();

    //Valable que pour recaptcha Invisible
    grecaptcha.execute();
    const token = grecaptcha.getResponse();
    const input = $('.form-newsletter__input');
    const inputValue = input.val();

    clearErrors();

    $.ajax({
      url: loadMoreParams.ajaxurl, // AJAX handler
      data: {
        'action': 'newsletterInscriptionSubmit',
        'email': inputValue,
        'g-recaptcha-response': token
      },
      type: 'POST',
      beforeSend: function(xhr) {
      },
      success: function(xhr) {
        const retour = JSON.parse(xhr);
        if (retour.errors.length > 0) {
          const errorDisplay = $('<div></div>')
              .addClass('form-newsletter__notif form-newsletter__notif--error')
              .text('Format d\'adresse incorrecte ou adresse déja utilisée');
          $('.form-newsletter__errors-container').html('').append(errorDisplay);
          grecaptcha.reset();
        } else {
          const successDisplay = $('<div></div>')
              .addClass('footer-newsletter__notif footer-newsletter__notif--success')
              .text('Merci de vous être inscrit !');

          $('.footer-newsletter').addClass('footer-newsletter--is-success').append(successDisplay);
          grecaptcha.reset();
        }
      },
      error: function () {
        const errorDisplay = $('<div></div>')
            .addClass('form-newsletter__notif form-newsletter__notif--error')
            .text('Une erreur est survenue.');
        $('.form-newsletter__errors-container').html('').append(errorDisplay);
        grecaptcha.reset();
      }
    });

  }

  $(document).ready(function() {
    init();
  });
}
